/**
 * Gated debug-logger for chat-funksjonen.
 *
 * Av som standard slik at sluttbrukere ikke får konsoll-spam i produksjon.
 * Skru på med `localStorage.setItem('debugChat', 'true')` og last appen på nytt.
 * Reelle feil logges fortsatt direkte med console.warn / console.error.
 */
let enabled = false;
try {
  // Skru på debug-logging eksplisitt: localStorage.setItem('debugChat', 'true').
  if (localStorage.getItem('debugChat') === 'true') {
    enabled = true;
  }
} catch {
  // localStorage utilgjengelig (tester/SSR) — la av-som-standard stå
}

export function chatLog(...args: unknown[]): void {
  if (enabled) {
    console.log(...args);
  }
}
